import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createBusinessMaster,
  listBusinessMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * BusinessMaster 新規登録 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 */
export function useCreateBusinessMaster(): InvalidatingMutationResultFor<
  typeof createBusinessMaster
> {
  return useInvalidatingMutation(createBusinessMaster, [
    createConnectQueryKey({
      schema: listBusinessMasters,
      cardinality: 'finite',
    }),
  ])
}
